import React from 'react'
import './adminApp.css';
import Sidebar from './components/Sidebar';

export default function adminLocationHistory() {
    return (
        <>
            <div className="txt-container">
                <Sidebar />
                <div>
                    <h1>Admin Location History page</h1>
                </div>
            </div>
        </>
    )
}
